if(typeof _GIRL_CONF['zoe']['game_memory']=='undefined'){_GIRL_CONF['zoe']['game_memory']={};};
_GIRL_CONF['zoe']['game_memory']['face']={left:567,top:93,width:136,height:297};
_GIRL_CONF['zoe']['game_memory']['hair']={left:524,top:3,width:224,height:399};
_GIRL_CONF['zoe']['game_memory']['hand1']={left:490,top:261,width:306,height:349};
_GIRL_CONF['zoe']['game_memory']['hand2']={left:481,top:263,width:307,height:339};
_GIRL_CONF['zoe']['game_memory']['item2']={left:223,top:352,width:146,height:293};
_GIRL_CONF['zoe']['game_memory']['item3']={left:296,top:604,width:645,height:150};
_GIRL_CONF['zoe']['game_memory']['tit1']={left:527,top:350,width:110,height:121};
_GIRL_CONF['zoe']['game_memory']['tit2']={left:622,top:342,width:116,height:129};
